import React from 'react';

// 表示名は学習者の言葉で書く（英語の内部名を出さない）。value は記録・着色に使うので変えない。
const MODEL_OPTIONS = [
  { value: 'Plate-rim', label: '丸皿のふち' },
  { value: 'Plate-foot', label: '丸皿の底（糸底）' },
  { value: 'Plate', label: '丸皿全体' },
  { value: 'Glass-top', label: 'グラスの飲み口' },
  { value: 'Glass-bottom', label: 'グラスの底' },
  { value: 'Glass', label: 'グラス全体' },
  { value: 'PlateAndGlass', label: '丸皿とグラス全体' },
];

// 辺の組み合わせ単位で選択させる（面単位では隣接面も歪むため誤り箇所が一意に定まらない）。
// 表示名は既定の視点から見た位置（左右＝画面の左右、奥／手前＝見る人から遠い／近い）で書く。
// 「付近」「（手前側含む）」のようなあいまいな言い方を避け、どの辺が赤くなるかが想像できる言い方にする
const CUBE_OPTIONS = [
  { value: 'Cube-topAndSide1', label: '上面の奥半分' },
  { value: 'Cube-topAndSide2', label: '上面の奥の3辺と奥の縦の辺' },
  { value: 'Cube-topAndSide3', label: '上面の手前半分' },
  { value: 'Cube-topAndSide4', label: '上面の手前の3辺と手前の縦の辺' },
  { value: 'Cube-topLeft', label: '上面の左奥の角' },
  { value: 'Cube-topRight', label: '上面の右奥の角' },
  { value: 'Cube-bottomRight', label: '底面の右側と右の縦の辺' },
  { value: 'Cube-bottomLeft', label: '底面の左側と左の縦の辺' },
  { value: 'Cube-topAll', label: '上面のふち全体' },
  { value: 'Cube', label: '立方体全体' },
];

// X-1 で「どの部品か分からない」ときの選択肢（allowUnknown のときだけ出す）。
// 値はそのまま記録され、どの部品にも一致しないので着色もされない。表示は選択式の自己説明の「△わからない」とそろえる
export const UNKNOWN_PART = '{unknown}';
const UNKNOWN_PART_LABEL = '△わからない';

// 選択部品の値（例: "Glass-top" / "Cube-topLeft"）を日本語ラベルへ変換する。
// SelfExp など他コンポーネントからも参照する。
export function getPartLabel(value) {
  if (!value) return '';
  if (value === UNKNOWN_PART) return UNKNOWN_PART_LABEL;
  const found = [...MODEL_OPTIONS, ...CUBE_OPTIONS].find((o) => o.value === value);
  return found ? found.label : value;
}

// disabled: 回答済みの問へ戻ってきたとき。選んだ結果は表示したまま操作だけ止める
// label: 左の見出し（ReactNode 可。演習の部品選択では手順番号つきの文言を渡す）
// attention: プルダウン自体を点滅させて「次はここ」と示す（未選択のときに使う）
// allowUnknown: 一覧の最後に「△わからない」を出す（演習の X-1。2026-10-14）
function ColoredPartSelecter({
  selectedPart, setSelectedPart, onApply, isCube = false, attentionOnApply = true, disabled = false,
  label = '着色する部品', attention = false, allowUnknown = false,
}) {
  const options = isCube ? CUBE_OPTIONS : MODEL_OPTIONS;
  return (
    <div className="colored-part-selecter">
      <label>{label}</label>
      <select
        value={selectedPart}
        onChange={(e) => setSelectedPart(e.target.value)}
        className={`colored-part-selecter__select${attention && !disabled ? ' form-input--attention' : ''}`}
        aria-label="部品選択"
        disabled={disabled}
      >
        <option value="">選択してください</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
        {allowUnknown && <option value={UNKNOWN_PART}>{UNKNOWN_PART_LABEL}</option>}
      </select>
      {/* 部品を選んだら、次に押す「着色を決定」を点滅で示す。
          onApply を渡さない画面（演習の部品選択）は選んだ時点で着色されるのでボタンを出さない */}
      {onApply && (
        <button
          onClick={onApply}
          disabled={disabled}
          className={`btn btn--apply${selectedPart && attentionOnApply && !disabled ? ' btn--attention' : ''}`}
        >
          着色を決定
        </button>
      )}
    </div>
  );
}

export default ColoredPartSelecter;
